module.exports = __webpack_public_path__ + "img/02.3290696a.png";